module.exports = __webpack_public_path__ + "02_face.4f6aecb2.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/boy/layer1/02_face.png
// module id = Fc4A
// module chunks = 0